import { render, staticRenderFns } from "./o-recaptcha.vue?vue&type=template&id=770eb1fc&"
import script from "./o-recaptcha.vue?vue&type=script&lang=js&"
export * from "./o-recaptcha.vue?vue&type=script&lang=js&"
import style0 from "./o-recaptcha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports